
import { AppModule} from '@/store/modules/app'
import Vue from 'vue'
import {Prop} from 'vue-property-decorator'

export default abstract class ShoppingCartButton extends Vue {
    abstract get allStepsCompleted(): boolean

    abstract get productType(): string | undefined

    abstract addToShoppingCart(): void
}
